const styles = {
  root: {},

  container: {
    flexDirection: { xs: 'column-reverse', lg: 'row' },
  },

  imageContainer: {
    position: 'relative',
    height: { xs: 200, lg: 400 },
    width: { xs: 200, lg: 400 },
  },

  mainImage: {
    borderRadius: 2,
  },

  postsContainer: {
    mt: { xs: 2, lg: 'unset' },
  },

  categories: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 1,
    alignItems: 'center',
  },

  icon: {
    padding: 1,
    borderRadius: 10,
  },

}
export default styles
